/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Tenant Relationship Data Transfer Object
 * @export
 * @interface TenantRelationshipDto
 */
export interface TenantRelationshipDto {
    /**
     * Unique identifier for the relationship
     * @type {string}
     * @memberof TenantRelationshipDto
     */
    id?: string;
    /**
     * Source tenant ID (requesting access)
     * @type {string}
     * @memberof TenantRelationshipDto
     */
    sourceTenantId?: string;
    /**
     * Source tenant name
     * @type {string}
     * @memberof TenantRelationshipDto
     */
    sourceTenantName?: string;
    /**
     * Target tenant ID (being accessed)
     * @type {string}
     * @memberof TenantRelationshipDto
     */
    targetTenantId?: string;
    /**
     * Target tenant name
     * @type {string}
     * @memberof TenantRelationshipDto
     */
    targetTenantName?: string;
    /**
     * Current status of the relationship
     * @type {string}
     * @memberof TenantRelationshipDto
     */
    status?: string;
    /**
     * User ID who requested the relationship
     * @type {string}
     * @memberof TenantRelationshipDto
     */
    requestedByUserId?: string;
    /**
     * User ID who approved the relationship
     * @type {string}
     * @memberof TenantRelationshipDto
     */
    approvedByUserId?: string;
    /**
     * When the relationship was approved
     * @type {Date}
     * @memberof TenantRelationshipDto
     */
    approvedAt?: Date;
    /**
     * Justification for the relationship request
     * @type {string}
     * @memberof TenantRelationshipDto
     */
    justification?: string;
    /**
     * When the relationship expires
     * @type {Date}
     * @memberof TenantRelationshipDto
     */
    expiresAt?: Date;
    /**
     * Whether the relationship requires periodic reapproval
     * @type {boolean}
     * @memberof TenantRelationshipDto
     */
    requiresReapproval?: boolean;
    /**
     * When the relationship was last reapproved
     * @type {Date}
     * @memberof TenantRelationshipDto
     */
    lastReapprovalAt?: Date;
    /**
     * When the relationship needs next reapproval
     * @type {Date}
     * @memberof TenantRelationshipDto
     */
    nextReapprovalAt?: Date;
    /**
     * User ID who revoked the relationship
     * @type {string}
     * @memberof TenantRelationshipDto
     */
    revokedByUserId?: string;
    /**
     * When the relationship was revoked
     * @type {Date}
     * @memberof TenantRelationshipDto
     */
    revokedAt?: Date;
    /**
     * Reason for revocation
     * @type {string}
     * @memberof TenantRelationshipDto
     */
    revocationReason?: string;
    /**
     * When the relationship was created
     * @type {Date}
     * @memberof TenantRelationshipDto
     */
    createdAt?: Date;
    /**
     * When the relationship was last updated
     * @type {Date}
     * @memberof TenantRelationshipDto
     */
    updatedAt?: Date;
}

/**
 * Check if a given object implements the TenantRelationshipDto interface.
 */
export function instanceOfTenantRelationshipDto(value: object): value is TenantRelationshipDto {
    return true;
}

export function TenantRelationshipDtoFromJSON(json: any): TenantRelationshipDto {
    return TenantRelationshipDtoFromJSONTyped(json, false);
}

export function TenantRelationshipDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantRelationshipDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'sourceTenantId': json['sourceTenantId'] == null ? undefined : json['sourceTenantId'],
        'sourceTenantName': json['sourceTenantName'] == null ? undefined : json['sourceTenantName'],
        'targetTenantId': json['targetTenantId'] == null ? undefined : json['targetTenantId'],
        'targetTenantName': json['targetTenantName'] == null ? undefined : json['targetTenantName'],
        'status': json['status'] == null ? undefined : json['status'],
        'requestedByUserId': json['requestedByUserId'] == null ? undefined : json['requestedByUserId'],
        'approvedByUserId': json['approvedByUserId'] == null ? undefined : json['approvedByUserId'],
        'approvedAt': json['approvedAt'] == null ? undefined : (new Date(json['approvedAt'])),
        'justification': json['justification'] == null ? undefined : json['justification'],
        'expiresAt': json['expiresAt'] == null ? undefined : (new Date(json['expiresAt'])),
        'requiresReapproval': json['requiresReapproval'] == null ? undefined : json['requiresReapproval'],
        'lastReapprovalAt': json['lastReapprovalAt'] == null ? undefined : (new Date(json['lastReapprovalAt'])),
        'nextReapprovalAt': json['nextReapprovalAt'] == null ? undefined : (new Date(json['nextReapprovalAt'])),
        'revokedByUserId': json['revokedByUserId'] == null ? undefined : json['revokedByUserId'],
        'revokedAt': json['revokedAt'] == null ? undefined : (new Date(json['revokedAt'])),
        'revocationReason': json['revocationReason'] == null ? undefined : json['revocationReason'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
    };
}

export function TenantRelationshipDtoToJSON(json: any): TenantRelationshipDto {
    return TenantRelationshipDtoToJSONTyped(json, false);
}

export function TenantRelationshipDtoToJSONTyped(value?: TenantRelationshipDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'sourceTenantId': value['sourceTenantId'],
        'sourceTenantName': value['sourceTenantName'],
        'targetTenantId': value['targetTenantId'],
        'targetTenantName': value['targetTenantName'],
        'status': value['status'],
        'requestedByUserId': value['requestedByUserId'],
        'approvedByUserId': value['approvedByUserId'],
        'approvedAt': value['approvedAt'] == null ? undefined : ((value['approvedAt']).toISOString()),
        'justification': value['justification'],
        'expiresAt': value['expiresAt'] == null ? undefined : ((value['expiresAt']).toISOString()),
        'requiresReapproval': value['requiresReapproval'],
        'lastReapprovalAt': value['lastReapprovalAt'] == null ? undefined : ((value['lastReapprovalAt']).toISOString()),
        'nextReapprovalAt': value['nextReapprovalAt'] == null ? undefined : ((value['nextReapprovalAt']).toISOString()),
        'revokedByUserId': value['revokedByUserId'],
        'revokedAt': value['revokedAt'] == null ? undefined : ((value['revokedAt']).toISOString()),
        'revocationReason': value['revocationReason'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
    };
}

